import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useSettings } from '@/context/SettingsContext';

const Navbar = () => {
  const { settings } = useSettings();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/projects', label: 'Projects' },
    { path: '/why-us', label: 'Why Us' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src={settings.logo_url || "https://customer-assets.emergentagent.com/job_34f43037-f49f-4896-a120-3461406a9d35/artifacts/wh0yojmq_e30d7691-c116-46a6-b645-fa81d1964b10-removebg-preview.png"} 
              alt="Infinity Group" 
              className="h-24 w-auto"
              data-testid="logo"
            />
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-gray-900">Infinity Group</span>
              <span className="text-sm italic text-gray-600">Dreams Unlimited</span>
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`nav-link text-base font-medium ${
                  isActive(link.path) ? 'text-red-700' : 'text-gray-700 hover:text-red-700'
                }`}
                style={{ color: isActive(link.path) ? '#C41E3A' : undefined }}
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact#enquiry-form"
              className="flex items-center gap-2 px-5 py-2 rounded-md text-white font-medium"
              style={{ background: 'linear-gradient(135deg, #C41E3A 0%, #8B2635 100%)' }}
              data-testid="header-enquire-btn"
            >
              Enquire Now
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-700"
            data-testid="mobile-menu-toggle"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white border-t" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block text-base font-medium py-2 ${
                  isActive(link.path) ? 'text-red-700' : 'text-gray-700'
                }`}
                style={{ color: isActive(link.path) ? '#C41E3A' : undefined }}
                data-testid={`mobile-nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact#enquiry-form"
              onClick={() => setIsOpen(false)}
              className="flex items-center justify-center gap-2 px-5 py-3 rounded-md text-white font-medium mt-4"
              style={{ background: 'linear-gradient(135deg, #C41E3A 0%, #8B2635 100%)' }}
              data-testid="mobile-enquire-btn"
            >
              Enquire Now
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;